<script>
  export default {
    name: 'ProductList',
    data() {
      return {
        totalPages: 0,
        pageNumber: 1,
        paginationInterval: 12,
        filters: [],
        products: []
      };
    },
    methods: {
      reset: function () {
        this.filters = [];
        this.products = [];
      },
      page: function (pageNumber) {
        this.pageNumber = pageNumber;
        this.loadFilteredProducts();
      },
      filterProducts: function (filters) {
        this.reset();

        this.filters = filters;
        this.loadFilteredProducts();
      },
      toggleProductInBasket($event, productId) {
        if (this.$root.isProductInBasket(productId)) {
          this.$root.removeProductFromBasket(productId)
        } else {
          this.$root.addProductToBasket(productId)
        }
      },
      loadFilteredProducts: function () {
        const pagination = {
          page: this.pageNumber,
          pagination_interval: this.paginationInterval
        };

        this.$root.$api.getProducts(pagination, this.filters)
          .then(response => {
            if (response.data != null) {
              this.products = response.data.products;
              this.totalPages = response.data.last_page;
            }
          }).catch(error => {
          console.log(error);
        })
      },
      loadRecommendedProducts: function (product) {
        this.$root.$api.getRecommendedProducts([product.id])
          .then(response => {
            if (response.data != null) {
              this.products = response.data.recommended_products;
              this.totalPages = response.data.last_page;
            }
          }).catch(error => {
          console.log(error);
        })
      }
    }
  }
</script>
